import { ARTICLE_TEMPLATE } from "./articleConstants";
import { ShopArticleTemplate } from "./ShopArticleTemplate";
import { SpotArticleTemplate } from "./SpotArticleTemplate";
import { NormalArticleTemplate } from "./NormalArticleTemplate";
import { MemoryArticleTemplate } from "./MemoryArticleTemplate";

export function ArticleContent({ article }) {
  if (!article) return null;

  switch (article.template) {
    case ARTICLE_TEMPLATE.SHOPS:
      return <ShopArticleTemplate article={article} />;

    case ARTICLE_TEMPLATE.SPOTS:
      return <SpotArticleTemplate article={article} />;

    case ARTICLE_TEMPLATE.NORMAL:
      return <NormalArticleTemplate article={article} />;

    case ARTICLE_TEMPLATE.MEMORY:
      return <MemoryArticleTemplate article={article} />;

    default:
      return <NormalArticleTemplate article={article} />;
  }
}
